module.exports = __webpack_public_path__ + "img/T003_150ppi.c0e45b30.png";